import axios from 'axios';
import { useState, useEffect, useCallback } from 'react';

const useGetData = () => {
  const [gridData, setGridData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    const getData = async () => {
      let rackData = await axios.get(
        `/api/storeCompartmentRoutes/veiwStoreOverview`
      );
      setGridData(rackData.data);
    };
    getData();
    setIsLoading(false);
  }, []);

  return {
    gridData,
    isLoading,
  };
};

export default useGetData;
